module.exports = __webpack_public_path__ + "static/media/005-Wechseln_ID_35.bb07aed2.mp3";